import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import Account from './Account/Account';
import {
  ContactPerson,
  DateTime,
  Table,
  TableCell,
  TablePerson
} from 'components/common/Elements/Elements';

import { moneyFormater } from 'utils/common';

import classes from './Table.module.scss';

const TableRow = ({ company, tableConf, row, mouseEnter }) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'companyName' && (
              <TableCell cellProps={cellProps}>
                <Account data={company} />
              </TableCell>
            )}
            {show && field === 'userCompanyEmail' && (
              <TableCell cellProps={cellProps}>
                <ContactPerson
                  person={company.userCompanyEmail}
                  email={company.userCompanyEmail}
                  personClass={classes.fullName}
                />
              </TableCell>
            )}
            {show && field === 'actionUserEmail' && (
              <TableCell cellProps={cellProps}>
                {company.actionUserEmail}
              </TableCell>
            )}
            {show && field === 'activity' && (
              <TableCell cellProps={cellProps}>{company.activity}</TableCell>
            )}
            {show && field === 'activityType' && (
              <TableCell cellProps={cellProps}>
                {company.activityType}
              </TableCell>
            )}
            {show && field === 'arrChanged' && (
              <TableCell
                classNameContent={
                  company.arrChanged && company.arrChanged !== 'NA'
                    ? company.arrChanged < 0
                      ? classes.red
                      : classes.green
                    : null
                }
                cellProps={cellProps}
              >
                {moneyFormater(company.arrChanged)}
              </TableCell>
            )}
            {show && field === 'createdDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.createdDate} time />
              </TableCell>
            )}
            {show && field === 'accountManager' && (
              <>
                {company.accountManager !== 'UnAssigned' ? (
                  <TableCell
                    cellProps={cellProps}
                    classNameContent={classes.center}
                  >
                    <TablePerson
                      person={
                        company.accountManager ? company.accountManager : 'NA'
                      }
                    />
                  </TableCell>
                ) : (
                  <TableCell cellProps={cellProps}>
                    {company.accountManager}
                  </TableCell>
                )}
              </>
            )}
            {show && field === 'customerSuccessEngineer' && (
              <>
                {company.customerSuccessEngineer !== 'UnAssigned' ? (
                  <TableCell
                    cellProps={cellProps}
                    classNameContent={classes.center}
                  >
                    <TablePerson
                      person={
                        company.customerSuccessEngineer
                          ? company.customerSuccessEngineer
                          : 'NA'
                      }
                    />
                  </TableCell>
                ) : (
                  <TableCell cellProps={cellProps}>
                    {company.customerSuccessEngineer}
                  </TableCell>
                )}
              </>
            )}
            {show && field === 'arrStatus' && (
              <TableCell cellProps={cellProps}>{company.arrStatus}</TableCell>
            )}
            {show && field === 'lastUpdate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.lastUpdate} time />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
